import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IndustrySector, IndustrySectorModel } from 'app/shared/components/interfaces/GetAllIndustrySectors.interface';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { DomainsService } from '../domains.service';

@Component({
  selector: 'app-domain-control',
  templateUrl: './domain-control.component.html',
  styleUrls: ['./domain-control.component.scss']
})
export class DomainControlComponent implements OnInit , AfterViewInit {

  subscribtions:Subscription[]=[]

  @Input() IndustrySector:IndustrySector= {} as IndustrySector;

  @Input() globalIndustryItem: IndustrySector = {} as IndustrySector;

  @Input() controlView: string = ""

  addIndustrySector = this.formbuilder.group({
    nameInEnglish: ["", Validators.required],
    nameInArabic: ["", Validators.required],
    industryCriticalCodesId: [null],
  })

  get getAddIndustrySector() {
    return this.addIndustrySector.controls
  }

  constructor(private domainsService: DomainsService, private toastrService: ToastrService, private formbuilder: FormBuilder, public activeModal: NgbActiveModal) { }
  
  ngAfterViewInit(): void {
    if(this.controlView == "edit")
      this.addIndustrySector.patchValue({
        nameInEnglish: this.IndustrySector.nameInEnglish,
        nameInArabic: this.IndustrySector.nameInArabic,
        industryCriticalCodesId: this.IndustrySector.industryCriticalCodesId,
      })
  }
  
  ngOnInit(): void {}

  submit() {
    if (this.addIndustrySector.valid)
      if (this.controlView == 'add')
        this.domainsService.postIndustrySector(this.addIndustrySector.value).subscribe({
          next: (res: any) => {
            this.toastrService.success(res.message)
          }, error: (res: any) => {
            this.toastrService.error(res.message)
          },
          complete:()=> {this.domainsService.GetIndustrySectors();this.activeModal.close()}
        })
      else {
        this.globalIndustryItem.nameInArabic = this.addIndustrySector.value.nameInArabic ;
        this.globalIndustryItem.nameInEnglish = this.addIndustrySector.value.nameInEnglish ;
        this.domainsService.updateIndustrySector(this.globalIndustryItem).subscribe({
          next: (res: any) => {
            this.toastrService.success(res.message)
          }, error: (res: any) => {
            this.toastrService.error(res.message)
          },
          complete:()=> {this.domainsService.GetIndustrySectors();this.activeModal.close()}
        })
      }
  }

}
